module.exports = __webpack_public_path__ + "static/media/Frame 5.e835c643.png";